import { render, staticRenderFns } from "./NormalSectionView.vue?vue&type=template&id=684210f6&scoped=true"
import script from "./NormalSectionView.vue?vue&type=script&lang=js"
export * from "./NormalSectionView.vue?vue&type=script&lang=js"
import style0 from "./NormalSectionView.vue?vue&type=style&index=0&id=684210f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684210f6",
  null
  
)

export default component.exports